import { HttpError } from "./HttpError";

/** Error HTTP 500 (error interno del servidor). */
export class ServerError extends HttpError {
  /** @param message Mensaje de error. */
  constructor(message: string) {
    super(message, 500);
  }
}
